import { noop } from 'lodash';

const navbarConfig = {
  menus: [
    {
      id: 0,
      parentId: null,
      icon: 'icon-avatar-entity-initials-default',
      label: 'LCA Cloud',
      avatar: 'LCA',
      isSeparate: true,
      url: '/',
      isActive: () => false,
      onClick: noop,
      moduleId: 'Dataserver,Databrowser',
    },
    {
      id: 1,
      parentId: null,
      icon: 'icon-ui-general-home',
      isSeparate: true,
      label: 'Home',
      url: '/',
      isActive: (path: string) => path === '/',
    },
    {
      id: 34,
      parentId: null,
      icon: 'icon-ui-general-file',
      label: 'Files',
      url: '/files',
      isActive: (path: string) => path === '/files',
      onClick: noop,
    },
    {
      id: 35,
      parentId: null,
      icon: 'icon-ui-general-actions',
      label: 'Jobs',
      url: '/jobs',
      isActive: (path: string) => path === '/jobs',
      onClick: noop,
    },
  ],
};

export default navbarConfig;
